export default [
    {
        path: '/cetak-barcode',
        redirect: '/cetak-barcode',
        name: 'cetakBarcode',
        component: () => import('@/views/NestedRoute.vue'),
        children: [
            {
                path: '',
                name: 'cetakBarcodeIndex',
                component: () => import('@/views/cetakBarcode/Index.vue'),
                meta: {
                    action: 'Lihat',
                    resource: 'cetakBarcode',
                    pageTitle: 'Cetak Barcode',
                    breadcrumb: [
                        {
                            text: 'Cetak Barcode',
                            active: true,
                        },
                    ],
                },
            },
        ]
    }
]